import * as selectAudienceUtils from './fbSelectAudienceModalUtils'
import { FB_PRIVACY_LEVEL } from '../../utils/enums'

export function getUniqueAboutSectionValues(
  records: Record<string, any>[] | null,
): string[] {
  if (!records) {
    return []
  }

  const values = records.map((o) => {
    const level = o?.setting?.level
    const name = o?.setting?.name
    if (level === FB_PRIVACY_LEVEL.CUSTOM && name !== 'Custom') {
      return `${name} (Custom)`
    }
    return name
  })

  return Array.from(new Set(values))
}

export function getUniquePrivacyLevelCounts(
  initialState: Record<string, selectAudienceUtils.PrivacySetting>,
): string | null {
  if (!initialState) {
    return null
  }

  const privacyLevelDisplayOrder = [
    FB_PRIVACY_LEVEL.ONLY_ME,
    FB_PRIVACY_LEVEL.FRIENDS,
    FB_PRIVACY_LEVEL.FRIENDS_OF_FRIENDS,
    FB_PRIVACY_LEVEL.CUSTOM,
    FB_PRIVACY_LEVEL.PUBLIC,
  ]

  const mapPrivacyLevelToCount = {
    [FB_PRIVACY_LEVEL.ONLY_ME]: 0,
    [FB_PRIVACY_LEVEL.FRIENDS]: 0,
    [FB_PRIVACY_LEVEL.FRIENDS_OF_FRIENDS]: 0,
    [FB_PRIVACY_LEVEL.CUSTOM]: 0,
    [FB_PRIVACY_LEVEL.PUBLIC]: 0,
  }

  const values = Object.values(
    initialState,
  ) as selectAudienceUtils.PrivacySetting[]

  values.forEach((privacySetting) => {
    mapPrivacyLevelToCount[privacySetting.level] += 1
  })

  const privacyLevelCountStrings = privacyLevelDisplayOrder
    .filter((privacyLevel) => mapPrivacyLevelToCount[privacyLevel] > 0)
    .map((privacyLevel) => {
      const count = mapPrivacyLevelToCount[privacyLevel]
      const displayName = {
        [FB_PRIVACY_LEVEL.ONLY_ME]: 'Only Me',
        [FB_PRIVACY_LEVEL.FRIENDS]: 'Friends',
        [FB_PRIVACY_LEVEL.FRIENDS_OF_FRIENDS]: 'Friends of Friends',
        [FB_PRIVACY_LEVEL.CUSTOM]: 'Custom',
        [FB_PRIVACY_LEVEL.PUBLIC]: 'Public',
      }[privacyLevel]
      return `${displayName} (${count})`
    })

  return privacyLevelCountStrings.join(', ')
}

export function allAboutSectionValuesEqual(
  records: Record<string, any>[] | null,
  value: string,
): boolean {
  if (!records) {
    return true
  }

  const anyValueIsUnequal = records.some((o) => o?.setting?.level !== value)

  return !anyValueIsUnequal
}

export function allPrivacySettingsFriendsOrStricter(
  initialState: Record<
    string,
    // This will be undefined if an item has been deleted from initialState
    // during an automation
    selectAudienceUtils.PrivacySetting | undefined
  > | null,
): boolean {
  if (
    initialState === null ||
    initialState === undefined ||
    Object.keys(initialState).length === 0
  ) {
    return false
  }

  const allValues = Object.values(initialState)

  return allValues.every((value) =>
    selectAudienceUtils.isPrivacySettingAsStrictOrStricter(
      value,
      selectAudienceUtils.FRIENDS,
    ),
  )
}

export function checkCantUndoPrivacySetting(
  records: Record<string, any>[] | null,
) {
  if (!records) {
    return false
  }

  return records.some(
    (o) => !selectAudienceUtils.isPrivacySettingUndoable(o?.setting),
  )
}
